(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-main"] && !Shopify.designMode) return;
  try {
    
  class HeroMainSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.interval = Number(this.dataset.interval) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.showSlide(Number(dot.dataset.slideIndex));
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.addEventListener('shopify:block:select', (event) => {
        const selectedSlide = event.target?.closest?.('[data-hero-slide]');
        if (!selectedSlide) return;

        this.showSlide(Number(selectedSlide.dataset.slideIndex));
        this.stop();
      });
      this.addEventListener('shopify:block:deselect', () => this.start());

      this.showSlide(this.currentIndex);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    showSlide(index) {
      if (this.slides.length === 0) return;

      const nextIndex = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.currentIndex = nextIndex;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.dots.forEach((dot) => {
        const isActive = Number(dot.dataset.slideIndex) === nextIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    next() {
      this.showSlide(this.currentIndex + 1);
    }

    start() {
      if (!this.autoplay || this.slides.length <= 1 || window.Shopify?.designMode) return;

      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('hero-main-slideshow')) {
    customElements.define('hero-main-slideshow', HeroMainSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
